import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { DialogService } from './dialog.service';
import { AlertService } from './alert.service';
import { UserService } from './user.service';
import { User } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class TfaService {
  userData!: User | null;

  constructor(
    private authService: AuthService,
    private dialogService: DialogService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private userService: UserService
  ) {
    this.userService.userData$.subscribe((res) => {
      this.userData = res;
    });
  }

  enableTfa(): Observable<boolean> {
    return new Observable((observer) => {
      const config = {
        image: 'assets/images/t2a/google_authenticator.svg',
        imageAlt: 'google authentification',
        title: 'WM_TECH_POOL.TFA.DIALOG.TITLE',
        app: 'tech',
        autoClose: false,
        fields: [{ type: 'qrcode' }, { name: 'tfaCode', label: 'WM_TECH.TFA.CODE', type: 'input', validators: [Validators.required] }],
      };

      const dialogRef = this.dialogService.openPopup(config);

      dialogRef.componentInstance.formSubmited.subscribe((result) => {
        if (result?.submited && result?.formValue?.tfaCode) {
          this.authService.enableTfa(result.formValue.tfaCode).subscribe(
            () => {
              this.alertService.showAlert(this.translateService.instant('TFA.ENABLED'), 'success');
              this.updateUserData(true);
              dialogRef.close({ checked: true });
              observer.next(true);
              observer.complete();
            },
            () => {
              dialogRef?.componentInstance?.form?.reset();
            }
          );
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.checked === true) {
          observer.complete();
        } else {
          observer.next(false);
        }
      });
    });
  }

  disableTfa(): Observable<boolean> {
    return new Observable((observer) => {
      const config = {
        image: 'assets/images/t2a/google_authenticator.svg',
        imageAlt: 'google authentification',
        title: 'WM_TECH_POOL.TFA.DIALOG.TITLE',
        app: 'tech',
        autoClose: false,
        fields: [{ name: 'tfaCode', label: 'WM_TECH.TFA.CODE', type: 'input', validators: [Validators.required] }],
      };

      const dialogRef = this.dialogService.openPopup(config);

      dialogRef.componentInstance.formSubmited.subscribe((result) => {
        if (result?.submited && result?.formValue?.tfaCode) {
          this.authService.disableTFA(result.formValue.tfaCode).subscribe(
            () => {
              this.alertService.showAlert(this.translateService.instant('TFA.DISABLED'), 'success');
              this.updateUserData(false);
              dialogRef.close({ checked: false });
              observer.next(true);
              observer.complete();
            },
            () => {
              dialogRef?.componentInstance?.form?.reset();
            }
          );
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.checked === false) {
          observer.complete();
        } else {
          observer.next(false);
        }
      });
    });
  }

  updateUserData(tfaStatus: boolean) {
    if (!this.userData) {
      return;
    }

    const updatedUserData = { ...(this.userData as unknown as User), tfaEnabled: tfaStatus };
    this.userService.setUserData(updatedUserData);
  }
}
